import Axios from "axios";
import { store } from "../store/store";

const BASE_URL = process.env.REACT_APP_BASE_URL_BACKEND;

var axios = Axios.create({
  withCredentials: true,
});

export const httpService = {
  get(endpoint, data) {
    return ajax(endpoint, "GET", data);
  },
  post(endpoint, data) {
    return ajax(endpoint, "POST", data);
  },
  put(endpoint, data) {
    return ajax(endpoint, "PUT", data);
  },
  delete(endpoint, data) {
    return ajax(endpoint, "DELETE", data);
  },
  patch(endpoint, data) {
    return ajax(endpoint, "PATCH", data);
  },
};

async function ajax(endpoint, method = "GET", data = null) {
  try {
    const token = store.getState().auth.token; 

    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const res = await axios({
      url: `${BASE_URL}api/${endpoint}`,
      method,
      data,
      params: method === "GET" ? data : null,
      headers,
    });
    
    return res.data;
  } catch (err) {
    console.log(
      `Had Issues ${method}ing to the backend, endpoint: ${endpoint}, with data: `,
      data
    );
    console.dir(err);
    throw err;
  }
}
